import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthHelper } from '../common/roles';
import { UserService } from '../services/user.service';

/** Доступ для менеджера, руководителя, администратора (аудит). */
export const isManagersGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const roles = userService.userInfo$$()?.roles;

  return AuthHelper.IsManagers(roles) ? true : router.createUrlTree(['/']); // редирект на главную
};

/** Доступ для директора и администратора (пользователи и журнал входов). */
export const isBossesGuard: CanActivateFn = () => (AuthHelper.IsBosses(inject(UserService).userInfo$$()?.roles) ? true : inject(Router).createUrlTree(['/']));
